import { Col, Form, Row, FormInstance, Switch } from "antd";
import PagamentoTipoSelect from "./PagamentoTipo/PagamentoTipoSelect";
import Pagamento from "../../../../../Models/Financeiro/Titulo/Pagamento/Pagamento";
import PagamentoTipo, { EnumPagamentoTipo } from "../../../../../Models/Financeiro/Titulo/Pagamento/PagamentoTipo";
import CreditoFormBasic from "./Credito/CreditoFormBasic";
import BoletoFormBasic from "./Boleto/BoletoFormBasic";
import PixFormBasic from "./Pix/PixFormBasic";
import { EnumTipoConta } from "@/Models/Financeiro/Conta";
import ContaSelect from "@/Components/Populados/Financeiro/Conta/ContaSelect";

interface IPagamentoFormBasicProps<T> {
    tiposPagamentoNaoPermitidas?:number[];
    form:FormInstance<T>;
    nameBase:string[];
    namePath:string[];
}
export default function PagamentoFormItem<T>({
    form,
    nameBase,
    namePath,
    tiposPagamentoNaoPermitidas
}:IPagamentoFormBasicProps<T>) {
    const tipo = Form.useWatch([...namePath, "tipo"], form) as PagamentoTipo|null;

    return <Row gutter={8} wrap>
        <Col xs={24} sm={12} md={8} lg={5}>
            <Form.Item<Pagamento> name={[...nameBase, "tipo"]} label="Forma" rules={[ { required : true } ]}>
                <PagamentoTipoSelect tipoInvalidos={tiposPagamentoNaoPermitidas} />
            </Form.Item>
        </Col>
        <Col xs={24} sm={12} md={8} lg={6}>
            <Form.Item<Pagamento> label="Conta" name={[...nameBase, "codConta"]} rules={[ { required : true } ]}>
                <ContaSelect filtros={{
                    encerrada : false,
                    codTiposInvalidos : [EnumTipoConta.ADIANTAMENTO_VIAGEM]
                }} />
            </Form.Item>
        </Col>
        {tipo?.codigo == EnumPagamentoTipo.Credito && <CreditoFormBasic form={form} nameBase={nameBase} namePath={namePath} />}
        {tipo?.codigo == EnumPagamentoTipo.Pix && <PixFormBasic form={form} nameBase={nameBase} namePath={namePath}  />}
        {tipo?.codigo == EnumPagamentoTipo.Boleto && <BoletoFormBasic form={form} nameBase={nameBase} namePath={namePath}  />}
        {/* {tipo?.codigo !== undefined && tipo?.codigo !== EnumPagamentoTipo.Boleto && <Col>
            <Form.Item label="Cancelamento?" name={[...nameBase, "cancelamento"]} rules={[ { required : true }]} initialValue={false}>
                <Switch checkedChildren="Sim" unCheckedChildren="Não"></Switch>
            </Form.Item>
        </Col>} */}
    </Row>
}